<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  ></div>
</template>

<script>
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import { initializeMoEngageTime } from "../helpers/moengageEvents";
import { initializeMetaTime } from "../helpers/metaEvents";
import {
  loadAmplitudeUnsentEvents,
  EVENT_PAGEVIEW_HOMEPAGE,
} from "../helpers/analyticsEvents";
import { getVwoExperimentsPromiseArray } from "../helpers/vwoSetup";
// import {
//   VWO_HOMEPAGE_EXPERIMENT,
//   VWO_EXPERIMENT_VARIANTS,
//   VWO_VARIANT_HOMEPAGE_HEADER_NAME,
// } from "../config/vwoKeys";

export default {
  name: "InitializeStore",
  components: {},
  data() {
    return {
      sessionDependedMethodsProcessed: false,
    };
  },
  async mounted() {
    if (!LocalStorageFunc.getFirstTimeUser()) {
      this.$store.commit(keyMapsMutation.UPDATE_HOME_SHIMMER, true);
      Utility.removeAddEditAddressFromStorage();
      setTimeout(
        () => this.$store.commit(keyMapsMutation.UPDATE_HOME_SHIMMER, false),
        1000
      );
    }
    // let fetchedVwoData = {};
    // await Promise.all([...getVwoExperimentsPromiseArray()])
    //   .then((data) => {
    //     data.forEach((element) => {
    //       for (let key in element) {
    //         fetchedVwoData[key] = element[key];
    //       }
    //     });
    //     this.$store.commit(
    //       keyMapsMutation.UPDATE_VWO_EXPERIMENTS,
    //       fetchedVwoData
    //     );
    //   })
    //   .catch((errors) => {});

    loadAmplitudeUnsentEvents();

    if (!LocalStorageFunc.accessToken()) {
      this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {});
    }
    setTimeout(() => {
      initializeMoEngageTime();
      initializeMetaTime();
    }, 5000);

    let bottombarMenuData =
      this.$store.getters[
        keyMapsGetter.GET_CATEGORY_NAME_AND_COUNT_FOR_BOTTOM_BAR
      ];
    let productCategoryData = this.$store.state.ProductItems.productCategory;
    Utility.categoryCounter(bottombarMenuData, productCategoryData);

    Utility.osBackButtonFunc();
    EVENT_PAGEVIEW_HOMEPAGE();

    let queryParams = Utility.getQueryFromUrl();
    if (queryParams["catg_id"]) {
      Utility.gotoElement({ id: queryParams["catg_id"] });
      window.history.pushState(
        "",
        "",
        window.location.href.split("&catg_id")[0]
      );
    } else if (queryParams["prod_id"]) {
      Utility.gotoElement({ type: "PRODUCT", id: queryParams["prod_id"] });
      window.history.pushState(
        "",
        "",
        window.location.href.split("&prod_id")[0]
      );
    }
    LocalStorageFunc.setIsAddEditAddressFlow(false);
    LocalStorageFunc.setCoordsForAddEditAddress({});
    LocalStorageFunc.setAddAddressEnable(false);
    LocalStorageFunc.setEditAddresEnable({});
    // if (
    //   LocalStorageFunc.getSessionStorageKey("previousScreenName", "") !==
    //   "hongs cart page"
    // ) {
    //   LocalStorageFunc.setTip({
    //     amount: 0,
    //     removed: false,
    //     autoApply: false,
    //   });
    // }
  },
  methods: {},
  computed: {
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (
        isSessionP &&
        !this.sessionDependedMethodsProcessed &&
        LocalStorageFunc.isLoggedIn()
      ) {
        let favIds = LocalStorageFunc.getSessionStorageKey("guestFavIds", []);
        if (favIds?.length) {
          this.$store.dispatch(keyMapsAction.ADDTO_FAVOURITE_API, favIds);
          LocalStorageFunc.unsetSessionStorageKey("guestFavIds");
        }
        this.sessionDependedMethodsProcessed = true;
      }
      this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false);
      return isSessionP;
    },
  },
};
</script>
